import { lazy } from "react";
import { Outlet } from "react-router-dom";
// auth
// layouts
import AuthClassicLayout from "../../layouts/auth/classic";

// ----------------------------------------------------------------------

// JWT
const JwtLoginPage = lazy(() => import("../../pages/auth/jwt/login"));

// ----------------------------------------------------------------------

const authJwt = {
  path: "/",
  element: <Outlet />,
  children: [
    {
      path: "login",
      element: (
        <AuthClassicLayout>
          <JwtLoginPage />
        </AuthClassicLayout>
      ),
    },
  ],
};

export const authRoutes = [
  {
    path: "/",
    children: [authJwt],
  },
];
